
export default {
    methods: {
        //Format duration in minutes into hours and minutes format
        hoursAndMinutes(duration) {
            if (duration !== 0) {
                let hours = Math.floor((duration / 60))
                let minutes = duration - (hours * 60)
                hours = hours !== 0 ? hours + 'h' : ''
                minutes = minutes !== 0 ? minutes + (hours === '' ? 'm' : '') : ''
                return `${hours}${minutes}`
            } else {
                //If duration equals zero, format time as 0h00
                return '0h00'
            }
        },
        dayOfWeek(dayNumber) {
            let weekdays = this.$moment.weekdays(true)
            return weekdays[dayNumber].charAt(0).toUpperCase() + weekdays[dayNumber].slice(1)
        },
        formatMonthName(date, type) {
            let month = ''
            if (type === 'monthNumber') {
                month = this.$moment(date + 1, 'MM').format('MMMM')
            } else {
                month = this.$moment(date, 'YYYY-MM-DD').format('MMMM')
            }
            return month.charAt(0).toUpperCase() + month.slice(1)
        },
        durationBetweenDates(startDate, endDate) {
            const duration = this.$moment.duration(this.$moment(endDate).diff(this.$moment(startDate))).asMinutes()
            return this.hoursAndMinutes(duration)
        },
        formatSchedules(schedules) {
            let formattedSchedules = []
            schedules.map(d => {
                let sameSchedule = formattedSchedules.filter(s => { return s.day_number === d.day_number })
                if(sameSchedule.length > 0) {
                    sameSchedule[0].schedules.push({
                        id: d.id,
                        start: d.start,
                        end: d.end
                    })
                } else {
                    let schedule = {
                        ...d,
                        schedules: [{
                            id: d.id,
                            start: d.start,
                            end: d.end
                        }]
                    }
                    formattedSchedules.push(schedule)
                }
            })
            return formattedSchedules
        }
    }
};
